module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq188-f43ccdc6a5ed0723404b175a3d7951b1.jpg";